import { render, staticRenderFns } from "./CompanyProviderSkeleton.vue?vue&type=template&id=1349641d&"
import script from "./CompanyProviderSkeleton.vue?vue&type=script&lang=js&"
export * from "./CompanyProviderSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProviderSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports